const jwt_customizer = {
    general: 'حدث خطأ أثناء تخصيص رمز JWT. يرجى المحاولة مرة أخرى لاحقًا.',
    can_not_create_for_admin_tenant: 'لا يمكن إنشاء مخصص رمز JWT للمستأجر الإداري.',
};
export default Object.freeze(jwt_customizer);
